"use strict";
// // defaultTheme 必须首先注册
// import defaultTheme from './default';
//
// import Theme from './theme';
//
// export { Theme as default, defaultTheme };
Object.defineProperty(exports, "__esModule", { value: true });
// 全局主题的方法
var global_1 = require("./global");
exports.getGlobalTheme = global_1.getGlobalTheme;
exports.registerGlobalTheme = global_1.registerGlobalTheme;
// 图表主题的方法
var theme_1 = require("./theme");
exports.getTheme = theme_1.getTheme;
exports.registerTheme = theme_1.registerTheme;
// 工具函数
var utils_1 = require("./utils");
exports.convertToG2Theme = utils_1.convertToG2Theme;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/theme/index.js
// module id = 119
// module chunks = 37